import * as yup from 'yup'

import { makeOptions } from '../resource.module'
import { countries } from '@server/constants'

const AddressSchema = (key='address') => ({
	key: key,
	type: 'object',
	label: 'Address',
	children: [
		{
			key: 'line1',
			label: "Address Line 1",
			type: 'text',
		},
		{
			key: 'line2',
			label: "Address Line 2",
			type: 'text',
			required: 'never'
		},
		{
			key: 'townCity',
			label: 'Town / City',
			type: 'text',
		},
		{
			key: 'country',
			label: 'Country',
			type: 'select',
			defaultValue: '',
			fieldProps: {
				options: makeOptions(countries),
			},
			validator: yup.string().oneOf(['', ...countries]),
		},
		{
			key: 'postCode',
			label: 'Post Code',
			type: 'text',
		},
	],
});

export default AddressSchema;


// WEBPACK FOOTER //
// ./src/modules/resource/fields/address.field.js